import React from "react"

import { IssuesTab } from "@/organisms/Drawers/components/IssuesTab"
import {
  getDefaultFiltersInventorySastIssuesDrawer,
  getDefaultParamsSastIssue
} from "@/organisms/Drawers/hooks/useParamsFilter"

import { buildQueryStringFromRecord } from "@/helpers/filters.helper"
import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const CodeIssueTab: React.FC<TabComponentProps> = (
  props: TabComponentProps
) => (
  <IssuesTab
    tabKey="sastIssues"
    getInitialParamsFilter={getDefaultFiltersInventorySastIssuesDrawer}
    defaultParams={getDefaultParamsSastIssue()}
    includeApplicationFilter
    exportQueryParams={(params: Record<string, any>) =>
      buildQueryStringFromRecord({ resourceId: props.record?.id, ...params })
    }
    {...props}
  />
)

export default CodeIssueTab
